/**
 * Домовленість транспорту SELECT-фільтрів таблиці: списки опцій приходять з
 * `GET /api/v1/filter` під ключем колонки (`valueField`), і бек очікує вибір
 * назад під ТИМ САМИМ ключем.
 *
 * Наразі суфікс порожній — ключ фільтра дорівнює `valueField` (`chNum` -> `chNum`).
 * Механізм суфікса лишаємо як єдине джерело правди для входу (мапер його знімає)
 * і виходу (серіалізація фільтра/сортування його додає): якщо бек знову змінить
 * формат — досить змінити лише цю константу. Тому файл не залежить від core:
 * і `TableFilterOptionsDtoMapper`, і `buildSelectFilterFieldNames` беруть суфікс
 * звідси.
 */
export const TABLE_FILTER_KEY_SUFFIX = "";

/**
 * Ключ колонки (`valueField`) -> ключ фільтра беку. За порожнього суфікса
 * повертає `valueField` як є (точна інверсія зняття суфікса у мапері опцій).
 */
export const appendFilterKeySuffix = (columnKey: string): string =>
  `${columnKey}${TABLE_FILTER_KEY_SUFFIX}`;
